import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../index.css";
const Detail = () => {
  const [detail, setDetail] = useState([]);
  const paramas = useParams();
 
  const Fetchdetail = () => {
    fetch(
      `https://www.themealdb.com/api/json/v1/1/lookup.php?i=${paramas.idMeal}`
    )
      .then((Response) => Response.json())
      .then((data) => {
        setDetail(data.meals);
      });
  };
  useEffect(() => {
    Fetchdetail();
  }, []);
  return (
    <>
      {detail &&
        detail.length > 0 &&
        detail.map((value) => (
          <section class="detail section bd-container" id="detail">
            <div class="detail__data">
              <span class="section-subtitle detail__initial">
                We cook the best tasty food
              </span>
              <h2 class="section-title detail__initial">{value.strMeal}</h2>
              <div class="detail__container  bd-grid">
                <img src={value.strMealThumb} alt="" class="detail__img" />

                <div class="detail__content bd-grid">
                  <h3 class="detail__title">Ingridients</h3>
                  <div className="ingredient__container bd-grid">
                    <div>
                      <ul>
                        {value.strIngredient1 && (
                          <li>
                            {" "}
                            <a href="#" class="footer__link">
                              {value.strIngredient1} - {value.strMeasure1}
                            </a>
                          </li>
                        )}
                        {value.strIngredient2 && (
                          <li>
                            {" "}
                            <a href="#" class="footer__link">
                              {value.strIngredient2} - {value.strMeasure2}
                            </a>
                          </li>
                        )}
                        {value.strIngredient3 && (
                          <li>
                            {" "}
                            <a href="#" class="footer__link">
                              {value.strIngredient3} - {value.strMeasure3}
                            </a>
                          </li>
                        )}
                        {value.strIngredient4 && (
                          <li>
                            {" "}
                            <a href="#" class="footer__link">
                              {value.strIngredient4} - {value.strMeasure4}
                            </a>
                          </li>
                        )}
                        {value.strIngredient5 && (
                          <li>
                            {" "}
                            <a href="#" class="footer__link">
                              {value.strIngredient5} - {value.strMeasure5}
                            </a>
                          </li>
                        )}
                        {value.strIngredient6 && (
                          <li>
                            {" "}
                            <a href="#" class="footer__link">
                              {value.strIngredient6} - {value.strMeasure6}
                            </a>
                          </li>
                        )}
                      </ul>
                    </div>
                    <div>
                      <ul>
                        {value.strIngredient7 && (
                          <li>
                            {" "}
                            <a href="#" class="footer__link">
                              {value.strIngredient7} - {value.strMeasure7}
                            </a>
                          </li>
                        )}
                        {value.strIngredient8 && (
                          <li>
                            {" "}
                            <a href="#" class="footer__link">
                              {value.strIngredient8} - {value.strMeasure8}
                            </a>
                          </li>
                        )}
                        {value.strIngredient9 && (
                          <li>
                            {" "}
                            <a href="#" class="footer__link">
                              {value.strIngredient9} - {value.strMeasure9}
                            </a>
                          </li>
                        )}
                        {value.strIngredient10 && (
                          <li>
                            {" "}
                            <a href="#" class="footer__link">
                              {value.strIngredient10} - {value.strMeasure10}
                            </a>
                          </li>
                        )}
                        {value.strIngredient11 && (
                          <li>
                            {" "}
                            <a href="#" class="footer__link">
                              {value.strIngredient11} - {value.strMeasure11}
                            </a>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="about__data"><span class="section-subtitle about__initial">How to cook</span><h2 class="section-title about__initial">Receipe</h2> <p class="about__description">{value.strInstructions}</p><a href="/" class="button">Place Order</a></div>
             
             
            </div>
          </section>
        ))}
    </>
  );
};
export default Detail;
